import React from 'react';

import cn from 'classnames';

import { IChecklistTask } from '@features/Checklist/model/types';
import { Checkbox, DraggableEl, Flex, UiText } from '@shared/ui';

import cls from './ChecklistDragPreview.module.css';

interface IChecklistDragPreviewProps {
    itemData: IChecklistTask;
}

export const ChecklistDragPreview = ({ itemData }: IChecklistDragPreviewProps) => (
    <Flex
        justify="between"
        align="start"
        gap={6}
        className={cn(cls.ChecklistDragPreview, itemData.isChecked && cls.isChecked)}
    >
        <Flex fullWidth align="start" gap={6}>
            <DraggableEl />
            <Checkbox isActive={itemData.isChecked} />
            <UiText
                variant="mediumPlain"
                tag="span"
                className={cn(cls.ChecklistDragPreviewText, itemData.isChecked && cls.isChecked)}
            >
                {itemData.text || 'напишите текст'}
            </UiText>
        </Flex>
    </Flex>
);
